import { useBackgroundJob } from '@/hooks/useBackgroundJob';
import React, { useState } from 'react';
import { JobProgressConsole } from './JobProgressConsole';

const SERVICES = [
  { id: '', label: 'Todos los servicios' },
  { id: 'audio', label: 'Audio' },
  { id: 'drive', label: 'Google Drive' },
  { id: 'empresas', label: 'Empresas' },
  { id: 'sysadmin', label: 'Sysadmin' },
  { id: 'asesores', label: 'Asesores' },
  { id: 'acta-regeneracion', label: 'Regeneración de Actas' },
];

export const BackgroundJobProcessor: React.FC = () => {
  const [service, setService] = useState('');
  const [limit, setLimit] = useState(50);

  const { isProcessing, isLoadingMore, hasMore, progress, logs, startJob, connectOnly, loadMoreLogs, cancelObservation } = useBackgroundJob(
    '/api/system-jobs/test-queue',
    '/api/system-jobs/stream',
    { service, limit }
  );

  return (
    <div className="p-6 bg-white rounded-xl shadow-sm border border-gray-200 transition-all duration-300">
      <div className="flex flex-col lg:flex-row justify-between items-start lg:items-center gap-4 mb-8">
        <div className="max-w-2xl">
          <h2 className="text-2xl font-bold text-gray-900 mb-2 flex items-center gap-2">
            <span className="w-3 h-3 bg-green-500 rounded-full animate-pulse"></span>
            Monitor de Logs en Tiempo Real
          </h2>
          <p className="text-sm text-gray-500">
            Visualiza eventos del sistema y procesos en segundo plano. Los logs se capturan directamente de Pino via Server-Sent Events.
          </p>
        </div>

        <div className="flex flex-wrap gap-2">
          <button
            onClick={connectOnly}
            disabled={isProcessing}
            className="px-5 py-2.5 bg-gray-100 hover:bg-gray-200 text-gray-700 rounded-lg transition-all text-sm font-semibold disabled:opacity-50"
          >
            Solo Conectar
          </button>
          <button
            onClick={() => startJob({ action: 'trigger_test' })}
            disabled={isProcessing}
            className="px-5 py-2.5 bg-blue-600 hover:bg-blue-700 text-white rounded-lg shadow-md hover:shadow-lg transition-all text-sm font-semibold disabled:opacity-50"
          >
            {isProcessing ? 'Procesando...' : 'Test Simple'}
          </button>
          <button
            onClick={() => startJob({ action: 'simulate_sync' })}
            disabled={isProcessing}
            className="px-5 py-2.5 bg-indigo-600 hover:bg-indigo-700 text-white rounded-lg shadow-md hover:shadow-lg transition-all text-sm font-semibold disabled:opacity-50"
          >
            Simular Sincronización
          </button>

          {(isProcessing || logs.length > 0) && (
            <button
              onClick={cancelObservation}
              className="px-5 py-2.5 bg-red-50 text-red-600 hover:bg-red-100 rounded-lg transition-all text-sm font-semibold"
            >
              Desconectar
            </button>
          )}
        </div>
      </div>

      {/* FILTROS */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6 p-4 bg-gray-50 border border-gray-100 rounded-xl">
        <div className="flex flex-col gap-1.5">
          <label className="text-xs font-bold text-gray-400 uppercase tracking-wider px-1">Filtro de Servicio</label>
          <select
            value={service}
            onChange={(e) => setService(e.target.value)}
            disabled={isProcessing}
            className="w-full bg-white border border-gray-200 rounded-lg py-2 px-3 text-sm text-gray-700 focus:ring-2 focus:ring-blue-500 outline-none transition-all disabled:opacity-50"
          >
            {SERVICES.map((s) => (
              <option key={s.id} value={s.id}>
                {s.label}
              </option>
            ))}
          </select>
        </div>
        <div className="flex flex-col gap-1.5">
          <label className="text-xs font-bold text-gray-400 uppercase tracking-wider px-1">Límite Histórico (Buffer)</label>
          <input
            type="number"
            value={limit}
            onChange={(e) => setLimit(parseInt(e.target.value || '0'))}
            disabled={isProcessing}
            placeholder="Ej: 50"
            className="w-full bg-white border border-gray-200 rounded-lg py-2 px-3 text-sm text-gray-700 focus:ring-2 focus:ring-blue-500 outline-none transition-all disabled:opacity-50"
          />
        </div>
      </div>

      <JobProgressConsole
        progress={progress}
        logs={logs}
        hasMore={hasMore}
        isLoadingMore={isLoadingMore}
        onLoadMore={loadMoreLogs}
        isProcessing={isProcessing}
      />
    </div>
  );
};
